var mapBoxMatches = [
    {
        type : 0,
        okan : ['radius'],
        mapbox : 'circle-radius',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapLayerName',
        color: false
    },
    {
        type : 0,
        okan : ['clusterCircleRadius'],
        mapbox : 'circle-radius',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapClusterLayerName',
        color: false
    },
    {
        type : 0,
        okan : ['appearance', 'background', 'color'],
        mapbox : 'circle-color',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapLayerName',
        color: true
    },
    {
        type : 0,
        okan : ['appearance', 'background', 'opacity'],
        mapbox : 'circle-opacity',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapLayerName',
        color: false
    },
    {
        type : 0,
        okan : ['appearance', 'stroke', 'width'],
        mapbox : 'circle-stroke-width',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapLayerName',
        color: false
    },
    {
        type : 0,
        okan : ['appearance', 'stroke', 'color'],
        mapbox : 'circle-stroke-color',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapLayerName',
        color: true
    },
    {
        type : 0,
        okan : ['appearance', 'stroke', 'opacity'],
        mapbox : 'circle-stroke-opacity',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapLayerName',
        color: false
    },
    {
        type : 0,
        okan : ['appearance', 'clustered', 'background', 'color'],
        mapbox : 'circle-color',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapClusterLayerName',
        color: true
    },
    {
        type : 0,
        okan : ['appearance', 'clustered', 'background', 'opacity'],
        mapbox : 'circle-opacity',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapClusterLayerName',
        color: false
    },
    {
        type : 0,
        okan : ['appearance', 'clustered', 'stroke', 'width'],
        mapbox : 'circle-stroke-width',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapClusterLayerName',
        color: false
    },
    {
        type : 0,
        okan : ['appearance', 'clustered', 'stroke', 'color'],
        mapbox : 'circle-stroke-color',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapClusterLayerName',
        color: true
    },
    {
        type : 0,
        okan : ['appearance', 'clustered', 'stroke', 'opacity'],
        mapbox : 'circle-stroke-opacity',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapClusterLayerName',
        color: false
    },
    {
        type : 0,
        okan : ['appearance', 'clustered', 'text', 'size'],
        mapbox : 'text-size',
        mapboxfn : 'setLayoutProperty',
        mapboxLayer : 'mapClusterTextLayerName',
        color: false
    },
    {
        type : 0,
        okan : ['appearance', 'clustered', 'text', 'color'],
        mapbox : 'text-color',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapClusterTextLayerName',
        color: true
    },
    {
        type : 0,
        okan : ['appearance', 'clustered', 'text', 'opacity'],
        mapbox : 'text-opacity',
        mapboxfn : 'setPaintProperty',
        mapboxLayer : 'mapClusterTextLayerName',
        color: false
    }


]

export default mapBoxMatches;